export default __webpack_public_path__ + "static/media/backgroud.b0d9bcba.png";